import { format } from 'date-fns';
import type { RtwStatus } from '@cls/shared';
import { isVisaExpired, isVisaExpiring } from '@cls/shared';

interface Props {
  status: RtwStatus | null | undefined;
  expiry?: string | Date | null;
}

export function RtwBadge({ status, expiry }: Props) {
  if (!status) return <span className="pill">RTW ?</span>;
  if (status === 'uk') return <span className="rtw-uk">UK</span>;
  if (status === 'iltr') return <span className="rtw-iltr">ILTR</span>;
  const expired = isVisaExpired(status, expiry);
  const soon = isVisaExpiring(status, expiry, 90);
  const label = expiry ? `VISA ${format(new Date(expiry), 'd MMM yy')}` : 'VISA';
  return (
    <span className={`rtw-visa ${expired ? 'rtw-visa-expired' : soon ? '' : ''}`}>
      {label}
    </span>
  );
}
